<template>
  <TheGreyWrapper>
    <TheHeader
      with-cross
      force-sm-style
      @close="$router.push('/opportunities')"
    />
    <BaseSection>
      <BaseTitle
        :small="true"
        class="mb-4"
      >
        Signature de la lettre de mission
      </BaseTitle>
      <BaseParagraph class="mb-8">
        {{ $t('Docusign redirect') }}
      </BaseParagraph>
      <BaseButton
        :title="title"
        :href="kycSignUrl"
        :theme="theme"
        @click.native="disableButton"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { API_URL } from '../../constants';
import { RESET_BANNER } from '../../store/mutation-types';
import TheHeader from '../../components/TheHeader.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseButton from '../../components/BaseButton.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';
import BaseTitle from '../../components/BaseTitle.vue';
import TheGreyWrapper from '../../components/TheGreyWrapper.vue';

export default {
  name: 'Validation',
  components: {
    TheHeader,
    BaseSection,
    BaseButton,
    BaseParagraph,
    BaseTitle,
    TheGreyWrapper,
  },
  data() {
    return {
      theme: 'primary',
      title: this.$t('Docusign redirect button'),
    };
  },
  computed: {
    ...mapState('kyc', ['form']),
    kycSignUrl() {
      if (this.form) {
        return `${API_URL}/kyc/${this.form.attributes.token}/docusign_url`;
      }
      return null;
    },
  },
  created() {
    this.$store.commit(RESET_BANNER);
    this.fetchValidated();
  },
  methods: {
    ...mapActions('kyc', ['fetchValidated']),
    disableButton() {
      this.theme = 'disabled';
      this.title = this.$t('Loading...');
    },
  },
};
</script>
